// @flow
import * as React from 'react';

function usePrevious<T>(value: T): T {
  const ref = React.useRef(value);

  React.useEffect(() => {
    ref.current = value; // assign the value of ref to the argument

    return function unmount() {
      // $FlowIgnore[incompatible-type]
      ref.current = null;
    };
  }, [value]); // this code will run when the value of 'value' changes

  return ref.current; // in the end, return the current ref value.
}

export { usePrevious };
